import axios from 'axios'

import {
  setAuthorizationInterceptor,
  setRefreshOnExpireInterceptor,
} from '@/services/interceptors'

const API_URL: string = import.meta.env.VITE_API_URL
const MAX_WAIT_TIME = 100000
export const BASE_URL = API_URL + 'api/v1'

const client = axios.create({
  baseURL: BASE_URL,
  timeout: MAX_WAIT_TIME,
  headers: { 'Content-Type': 'application/json' },
})

setAuthorizationInterceptor(client)
setRefreshOnExpireInterceptor(client)

export default client
